/* eslint-disable react-hooks/exhaustive-deps */
// @vendors
import { useTranslation } from 'react-i18next';
import { CheckCircleIcon } from "@heroicons/react/24/solid";
import { PhotoIcon } from '@heroicons/react/24/outline';

// @store
import useAuthStore from '../../../../store/useAuthStore';
import { useCompanyStore } from '../../../../store/useCompanyStore';

//@types
import { Statistic } from '../../../../types/statistic.types';

// @helpers
import { getNameUser } from '../../../../helpers/functionsUtils';

const UserProfile: React.FC<{ logo: string, statistics: Statistic | undefined }> = ({ logo, statistics }) => {
    const { user, roleList } = useAuthStore();
    const { data, userData } = useCompanyStore();
    const { t } = useTranslation();

    const HelloUser = () => {
        const name = data?.name ?? '';
        return `${t("professional.dashboard.hello")} ${name.split(" ")[0]}`;
    }

    const mapStatistic = (value: number = 0, text: string) => {
        return (
            <div className="border border-cBorder p-2 rounded-full w-full flex flex-row gap-2 text-center items-center">
                <CheckCircleIcon className="size-6 text-textBrand" />
                <p className="text-sm text-gray-600 dark:text-dark-cText/60">
                    {value} {text}
                </p>
            </div>
        )
    }

    return (
        <div className="w-full flex flex-col lg:flex-row items-center gap-6">

            <div className="relative flex flex-col items-center justify-center text-center gap-[8px] w-[45%]">
                <div className="w-full flex flex-col items-center mb-3">
                    <img
                        src={logo ? logo : '/assets/img/no-image.png'}
                        alt="Company logo"
                        className="size-40 rounded-full object-cover"
                    />
                    <div className="bg-[#FB8D87] rounded-[100%] p-3 mt-[-25px]">
                        <PhotoIcon className="w-[20px] text-white" />
                    </div>
                </div>
                <p className='dark:text-dark-cText'>{getNameUser(roleList, data, userData)}</p>
                <p className='dark:text-dark-cText/50 text-[13px]'>{user?.email}</p>
                <p className='dark:text-dark-cText/50 text-[13px]'>{data?.category.name}</p>
            </div>

            <div className="text-center md:text-left flex-grow lg:w-[55%] w-[100%]">
                <div className="flex flex-row items-center">
                    <div>
                        <h2 className="text-[22px] font-bold text-cText mb-[15px] dark:text-dark-cText">
                            {HelloUser()}
                        </h2>
                        <p className="text-cTextSecondary dark:text-dark-cText/60">
                            {t("professional.dashboard.records")}
                        </p>
                    </div>
                    <div>
                        <img
                            src={"/assets/img/hand.svg"}
                            alt="Hands"
                            className="size-20"
                        />
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
                    {mapStatistic(statistics?.quotes, t("professional.dashboard.quotes"))}
                    {mapStatistic(statistics?.followers, t("professional.dashboard.followers"))}
                    {mapStatistic(statistics?.servicesCompleted, t("professional.dashboard.services"))}
                    {mapStatistic(statistics?.likes, t("professional.dashboard.likes"))}
                    {mapStatistic(statistics?.sales, t("professional.dashboard.sales"))}
                    {mapStatistic(statistics?.reelsPosted, t("professional.dashboard.reels"))}
                </div>
            </div>
        </div>
    )
}

export default UserProfile